export const SET_BREADCRUMB = '@manakin/core/dist/SET_BREADCRUMB';

export function setBreadcrumb(path, data) {
    return {
        type: SET_BREADCRUMB,
        payload: {
            data,
            path,
        },
    };
}
